<template>
    <div class="container has-text-left margin_top_1rem">
        <b-field label="Name">
            <b-input v-model="name" required></b-input>
        </b-field>
        <b-field label="HTTP method">
            <b-select v-model="method">
                <option v-for="m in availableMethods" :key="m" :value="m">{{m}}</option>
            </b-select>
        </b-field>
        <b-field label="URL">
            <b-input v-model="url" required placeholder="http://IP/..."></b-input>
        </b-field>
        <b-field label="Headers (optional)">
            <b-input v-model="headers" placeholder="Enter HTTP headers"></b-input>
        </b-field>
        <b-field label="Parameter value replacement (optional, if needed)">
            <b-input v-model="replacement" placeholder="Specify which replacement string is used in URL"></b-input>
        </b-field>
        <div class="buttons">
            <b-button type="is-danger-outlined" @click="handleAbort">Abort</b-button>
            <b-button type="is-success" :disabled="!validFields()" @click="handleAdd">Add Endpoint</b-button>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";
  import BSelect from "buefy/src/components/select/Select";

  export default {
    components: {
      BSelect,
      BButton,
      BInput,
      BField
    },
    name: "add-device-endpoint",
    props: ['deviceId', 'onAbort'],
    data() {
      return {
        name: '',
        method: 'GET',
        url: '',
        headers: '',
        replacement: 'PARAM'
      };
    },
    computed: {
      availableMethods() {
        return ['GET', 'POST'];
      }
    },
    methods: {
      ...mapActions('devices', ['addDeviceEndpoint']),
      validFields() {
        if (this.name.length < 1) {
          return false;
        }
        if (this.url.length < 8) {
          return false;
        }

        return true;
      },
      handleAdd() {
        this.addDeviceEndpoint({
          id: this.deviceId,
          name: this.name,
          method: this.method,
          url: this.url,
          headers: this.headers,
          replacement: this.replacement
        });
        this.handleAbort();
      },
      handleAbort() {
        this.resetFields();
        if (typeof this.onAbort === 'function') {
          this.onAbort();
        }
      },
      resetFields() {
        this.name = '';
        this.method = 'GET';
        this.url = '';
        this.headers = '';
        this.replacement = 'PARAM';
      }
    }
  }
</script>

<style scoped>
    .margin_top_1rem {
        margin-top: 1rem;
    }
</style>